(ns pfo.signature.core
  (:require
   [pfo.util :as util]
   [pfo.signature.component :as component]
   [pfo.revroutes :refer [path-for set-waypoint go-to-deletion-waypoint go-to-last-waypoint]]
   [pfo.controller :as controller :refer [subscribe]]))


(defn sign [{:keys [token _]}]
  (util/set-page-with-meta {:login-layout true} #'component/sign token))

(defn view [{:keys [token _]}]
  (util/set-page-with-meta {:login-layout true} #'component/view token))

(defn link [{:keys [task-id date]}]
  (controller/dispatch :signature :link
    {:task-id task-id
     :complete-by date
     :on-success (fn [link-info]
                   (condp = (:action link-info)
                     "open_step" (util/set-location
                                   (path-for
                                     :task-details
                                     :id task-id
                                     :complete_by date
                                     :query-params "highlighted=1"))
                     "sign" (util/set-location (:url link-info))
                     nil))}))
